export default {
  stickyLinks: {
    ml: ['24px', '24px', '48px', '48px', '133px'],
    width: ['calc(100% - 24px)', 'calc(100% - 24px)', 'calc(100% - 48px)', 'calc(100% - 48px)', 'calc(100% - 133px)'],
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '.swiper': {
      width: '100%',
      overflow: 'hidden'
    },
    '.swiper-slide': {
      width: 'auto',
      height: 'auto'
    }
  },
  stickyLinksContent: {
    width: 'auto',
    display: 'flex'
  },
  linkButton: (active?: boolean) => ({
    fontFamily: 'uniformMedium',
    mr: '40px',
    pb: '3px',
    borderBottom: '1px solid',
    transition: 'border .3s linear',
    whiteSpace: 'nowrap',
    borderBottomColor: active ? 'darkGrey700' : 'transparent',
    '&:hover': {
      borderBottomColor: 'darkGrey700'
    },
    '&:focus': {
      borderBottomColor: active ? 'darkGrey700' : 'transparent'
    },
    '&:last-of-type': {
      pr: ['24px', '24px', '48px', '48px', '0']
    }
  })
};